import React from "react";
import styled from "styled-components";
import { Card, CardBody, Text } from "@pancakeswap-libs/uikit";

import { useTotalValueLocked } from "state/hooks";
import useI18n from "hooks/useI18n";
import CardValue from "./CardValue";

const StyledTotalValueLockedCard = styled(Card)`
  align-items: center;
  display: flex;
  flex: 1;
  background: linear-gradient(
    162.44deg,
    #000000 49.97%,
    rgba(0, 0, 0, 0) 98.44%
  );
  border: 1px solid #ffffff;
  box-sizing: border-box;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  border-radius: 20px;
  margin-bottom: 20px;
  .tvl {
    width: 290px;
    justify-content: space-between;
    display: flex;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 14px;
    @media (max-width: 425px) {
      width: 250px;
      font-size: 20px;
    }
  }
`;

const TotalValueLockedCard = () => {
  const TranslateString = useI18n();
  const vempDetails: any = useTotalValueLocked();

  return (
    <StyledTotalValueLockedCard>
      <CardBody style={{ margin: "auto" }}>
        <div className="tvl">
          <p>Total Value Locked</p>
          <p> (TVL)</p>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <CardValue
            fontWeigt={600}
            fontSize="39px"
            value={vempDetails?.LOCKED_AMOUNT_DISPLAY}
            decimals={2}
          />
          <Text color="textSubtle" style={{ fontSize: "20px" }}>
            {TranslateString(999, "Across all worlds and Pools")}
          </Text>
        </div>
      </CardBody>
    </StyledTotalValueLockedCard>
  );
};

export default TotalValueLockedCard;
